<template>
    <div id="login">
        <div class="login-form">
            <el-form :model="ruleForm"
                     :rules="rules"
                     ref="ruleForm"
                     label-width="0">
                <h1>爱疯验证后台管理系统</h1>
                <el-form-item label=""
                              size="small"
                              prop="account">
                    <el-input v-model="ruleForm.account"
                              @keyup.enter.native="login"
                              prefix-icon="iconfont icon-yonghu"
                              placeholder="请输入用户名"></el-input>
                </el-form-item>
                <el-form-item label=""
                              size="small"
                              prop="password">
                    <el-input type="password"
                              v-model="ruleForm.password"
                              @keyup.enter.native="login"
                              prefix-icon="iconfont icon-suoding"
                              placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-form-item class="m0"
                              label-width="0">
                    <el-button type="primary"
                               class="w100"
                               size="small"
                               :loading="loginLoading"
                               @click="login('ruleForm')">登 录</el-button>
                </el-form-item>
                <div class="errTip"
                     v-show="loginErrTip">{{loginErrTip}}</div>
            </el-form>
        </div>
    </div>
</template>

<script>
    import { mapMutations } from 'vuex'
    // import homeServer from '@/api/home-server.js'
    export default {
        data() {
            var validateUsername = (rule, val, callback) => {
                if (!val) {
                    return callback(new Error('请输入用户名'));
                } else {
                    callback()
                }
            }
            var validatePassword = (rule, val, callback) => {
                if (!val) {
                    return callback(new Error('请输入密码'));
                } else {
                    callback()
                }
            }
            return {
                ruleForm: {
                    account: '',
                    password: '',
                },
                rules: {
                    account: [
                        { validator: validateUsername, trigger: 'blur' }
                    ],
                    password: [
                        { validator: validatePassword, trigger: 'blur' }
                    ],
                },
                loginLoading: false,
                loginErrTip: ''
            }
        },
        methods: {
            ...mapMutations({
                setAccount: 'setAccount'
            }),
            login() {
                this.loginErrTip = ''
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        this.loginLoading = true
                        this.$store.dispatch('asynclogin', this)
                        // homeServer.login(this.ruleForm).then(res => {
                        //     this.loginLoading = false
                        //     if (res.data.token) {
                        //         sessionStorage.setItem('token', res.data.token)
                        //         this.setAccount(this.ruleForm.account || '')
                        //         this.$router.push({
                        //             path: '/home',
                        //         })
                        //     } else {
                        //         this.loginErrTip = res.message
                        //     }
                        // })
                    } else {
                        return false
                    }
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    #login {
        height: 100vh !important;
        padding: 0 !important;
        border: none !important;
        background-color: #2e5266 !important;
        display: flex;
        flex-direction: column;
        justify-content: center;
        h1 {
            text-align: center;
            font-size: 22px;
            font-weight: bold;
            padding-bottom: 30px;
            color: #2e5266;
            text-shadow: 0 0 2px #6e8898;
        }
        .login-form {
            width: 230px;
            padding: 30px;
            margin: 0 auto;
            background-color: #e6f6f7;
            border-radius: 7px;
            border: 1px solid #ebeef5;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
        }
        .errTip {
            color: #f56c6c;
            font-size: 12px;
        }
    }
</style>